var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-2 slide-image",class:{
    'has-bg-image': _vm.isLayoutFullScreen,
  }},[_c('div',{staticClass:"flex image-body"},[(_vm.isLayoutCenter && _vm.slideActive.image)?_c('img',{attrs:{"alt":"","src":_vm.slideActive.image.xLarge}}):_vm._e()]),(_vm.slideActive.subheading && _vm.slideActive.subheading.trim() !== '')?_c('div',{staticClass:"pb-0 caption",class:{
      'small-text': _vm.isLayoutCenter && _vm.isSubheadingTooLong,
      'white': _vm.isLayoutFullScreen && _vm.slideActive.image && _vm.slideActive.textColour == '#ffffff',
      'black': _vm.isLayoutFullScreen && _vm.slideActive.image && _vm.slideActive.textColour == '#313131',
    }},[_c('div',{staticClass:"caption-text",domProps:{"innerHTML":_vm._f("sanitize")(_vm.slideActive.subheading,true)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }